import { useEffect } from 'react';
import { useAuth } from "../../utils/auth/useAuth";

const AuthLoginTimeTracker = () => {
  const { authState } = useAuth();

  // useEffect(() => {
  //       const loginTime = localStorage.getItem("ph-login-time");
  //       if(loginTime) {
  //         // console.log("---LOGIN TIME ALREADY SET---")
  //       } else {
  //         // console.log("---SAVING LOGIN TIME---")
  //         const now = new Date();
  //         localStorage.setItem("ph-login-time", Date.now())
  //         localStorage.setItem("ph-login-time-display", now.toLocaleString())
  //       }
  // }, []);
  useEffect(() => {
    if (authState?.isAuthenticated) {
      const loginTime = localStorage.getItem("ph-login-time");
      if (!loginTime) {
       // console.log("---SAVING LOGIN TIME---")
        const now = new Date();
        localStorage.setItem("ph-login-time", Date.now());
        localStorage.setItem("ph-login-time-display", now.toLocaleString());
        sessionStorage.setItem("showLoginAnimation", "true");
      } else {
        // console.log("---LOGIN TIME ALREADY SET---")
      }
    } else {
        // console.log("-----------SKIPPING")
        if (authState?.isAuthenticated == false){
          localStorage.removeItem("ph-login-time");
          localStorage.removeItem("ph-login-time-display");
          localStorage.removeItem("ph-alert-shown");
          localStorage.removeItem("ph-nps-shown");
        }
        
    }
  }, [authState]);

  return null; // no UI
};

export default AuthLoginTimeTracker;